
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type alphabeticalContainerRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function alphabeticalContainerRT(): TemplateResult<alphabeticalContainerRTRootProps> {
    function repeatAlphabeticalLetters1(alphabeticalLetters, alphabeticalLettersIndex) {
        return [alphabeticalLetters(function () {
                return _createElement('div', {
                    'className': 'cm_vehicle-categories__letters-letter' + (this.currentLetter === this.letter ? ' active' : '') + (this.isDisabled ? ' disabled' : ''),
                    'title': this.letter,
                    'onClick': () => this.setCurrentLetter(this.letter)
                }, '\n  ', this.letter, '\n');
            }, { count: undefined })];
    }
    function repeatAlphabeticalGroups2(view, alphabeticalGroups, alphabeticalGroupsIndex) {
        return [alphabeticalGroups(function () {
                function repeatTiles1(tiles, tilesIndex) {
                    return [tiles(function () {
                            return _createElement('a', {
                                'className': 'cm_vehicle-categories_category-container cm_vehicle-categories_link',
                                'href': this.href
                            }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container cm_vehicle-categories_link' }, this.imageUrl ? _createElement('img', {
                                'className': 'cm_vehicle-categories_category-image',
                                'src': this.imageUrl,
                                'alt': this.value,
                                'key': '214'
                            }) : null, !this.imageUrl ? _createElement('span', {
                                'className': 'cm_vehicle-categories_category-image-text',
                                'key': '340'
                            }, this.value) : null), _createElement('h3', { 'className': 'cm_vehicle-categories_category-title' }, this.value));
                        }, { count: undefined })];
                }
                function repeatTiles2(tiles, tilesIndex) {
                    return [tiles(function () {
                            return _createElement('a', {
                                'className': 'cm_vehicle-categories_category-wrapper-title-link',
                                'href': this.href,
                                'title': this.value
                            }, _createElement('h3', { 'className': 'cm_vehicle-categories_category-wrapper-title-link-text' }, this.value));
                        }, { count: undefined })];
                }
                return this.tiles.length ? _createElement('div', {
                    'className': 'cm_vehicle-categories_category-wrapper',
                    'key': '0'
                }, view === 'grid' ? [
                    _createElement('h2', {
                        'className': 'cm_vehicle-categories_category-repeater-letter',
                        'key': '821'
                    }, this.letter),
                    _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_vehicle-categories_category-repeater  cmRepeater_tiles',
                            'key': '823'
                        },
                        _map(this.tiles, repeatTiles1.bind(this))
                    ])
                ] : null, view === 'columns' ? [
                    _createElement('h2', {
                        'className': 'cm_vehicle-categories_category-repeater-letter',
                        'key': '12641'
                    }, this.letter),
                    _createElement('div', {
                        'className': 'cm_vehicle-categories_category-repeater-container',
                        'key': '12643'
                    }, _createElement.apply(this, [
                        'div',
                        { 'className': 'cm_vehicle-categories_category-repeater  cmRepeater_tiles' },
                        _map(this.tiles, repeatTiles2.bind(this))
                    ]))
                ] : null) : null;
            }, { count: undefined })];
    }
    function scopeView3() {
        var view = this.view;
        return _createElement.apply(this, [
            'div',
            { 'className': 'cm_vehicle-categories_category-wrapper-repeater' + (this.currentLetter !== 'All' ? ' filtered' : '') + '  cmRepeater_alphabeticalGroups' },
            _map(this.alphabeticalGroups, repeatAlphabeticalGroups2.bind(this, view))
        ]);
    }
    return _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__alphabetical cm_vehicle-categories__alphabetical-' + this.view }, [this.vehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatEntry1(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n            ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n          ');
                        }
                        function repeatEntry2(popularEntries, unpopularEntries, isPopularField, entry, entryIndex) {
                            return _createElement('option', {
                                'disabled': this.loading,
                                'value': entry.term,
                                'key': entry.value
                            }, '\n          ', entry.value, this.showHitCount ? ` (${ entry.hitCount })` : '', '\n        ');
                        }
                        function scopePopularEntriesUnpopularEntriesIsPopularField3() {
                            var popularEntries = this.entries.filter(entry => entry.payload === 'Popular');
                            var unpopularEntries = this.entries.filter(entry => entry.payload !== 'Popular');
                            var isPopularField = popularEntries.length && unpopularEntries.length;
                            return [
                                !(this.hideNullOption && this.entries.some(e => e.selected)) ? _createElement('option', {
                                    'value': '',
                                    'key': 'null-option'
                                }, '\n          ', _translate(`select_title`), ' ', this.title, '\n        ') : null,
                                this.loading ? _createElement('option', {
                                    'key': 'loading-option',
                                    'disabled': true
                                }, _translate(`select_loading`)) : null,
                                isPopularField ? [
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-popular',
                                        'disabled': true,
                                        'key': '11021'
                                    }, _translate(`ymm_bar_popular`)),
                                    _map(popularEntries, repeatEntry1.bind(this, popularEntries, unpopularEntries, isPopularField)),
                                    _createElement('option', {
                                        'className': 'cm_option_title cm_option-unpopular',
                                        'disabled': true,
                                        'key': '11024'
                                    }, _translate(`ymm_bar_unpopular`))
                                ] : null,
                                _map(isPopularField ? unpopularEntries : this.entries, repeatEntry2.bind(this, popularEntries, unpopularEntries, isPopularField))
                            ];
                        }
                        function scopeShowSelectedValues4() {
                            var showSelectedValues = this.selectedEntries.length;
                            return _createElement('option', {
                                'key': '_current',
                                'value': '_current'
                            }, showSelectedValues ? [this.selectedEntries.map(e => e.value).join(', ')] : null, !showSelectedValues ? [
                                _translate(`select_title`),
                                ' ',
                                this.title
                            ] : null);
                        }
                        function repeatEntry5(entry, index) {
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value,
                                'onClick': () => this.onChange(entry.term)
                            }, this.showCheckboxes ? _createElement('input', {
                                'type': 'checkbox',
                                'readOnly': true,
                                'checked': entry.selected,
                                'className': 'cm_dropdown_checkbox cm_facet_checkbox',
                                'key': '3324'
                            }) : null, _createElement('div', { 'className': 'cm_dropdown_value' }, entry.value), this.showHitCount ? _createElement('div', {
                                'className': 'cm_dropdown_hitCount',
                                'key': '3526'
                            }, entry.hitCount) : null);
                        }
                        return _createElement('div', { 'className': this.extraClassName }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle' + (this.useNativeDropdown ? ' cm_select_toggle__native' : '') + ' cm_toggle-dropdown',
                            'key': '39'
                        }, _createElement('select', {
                            'className': 'cm_select_inner-select cm_select__pretty',
                            'onChange': this.onChange,
                            'value': this.useNativeDropdown ? this.firstSelectedTerm || '' : '_current',
                            'disabled': this.disabled,
                            'aria-label': this.title
                        }, this.useNativeDropdown ? scopePopularEntriesUnpopularEntriesIsPopularField3.apply(this, []) : null, !this.useNativeDropdown ? scopeShowSelectedValues4.apply(this, []) : null)) : null, this.isSearchable ? [[this.filterInput(function () {
                                    return _createElement('div', { 'className': 'cm_filterInput' });
                                }, {
                                    widgetName: 'undefined',
                                    items: undefined
                                })]] : null, !this.disabled && !this.useNativeDropdown ? _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown cm_hide',
                                'aria-label': this.title,
                                'key': '2586'
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n      ', _translate(`select_title`), ' ', this.title, '\n    ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry5.bind(this)) : null
                        ]) : null);
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__vehicle-categories cm_vehicleWidget' }, this.template === 'active' ? _createElement('div', {
                'className': 'cm_vehicle-widget_dropdowns cmTemplate_active',
                'key': '86'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, !this.isVehicleSelected ? [this.name === 'VehicleWidgetDialog' ? 'Add Your Vehicle' : 'Select Your Vehicle'] : null, this.isVehicleSelected ? [this.vehicleString] : null), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ]), _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go cm_button cm_button__primary',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, this.name !== 'VerifyFitment' ? [_createElement('svg', {
                    'width': '13',
                    'height': '13',
                    'viewBox': '0 0 13 13',
                    'fill': 'none',
                    'xmlns': 'http://www.w3.org/2000/svg',
                    'key': '65840'
                }, _createElement('circle', {
                    'cx': '5.5',
                    'cy': '5.5',
                    'r': '4.5',
                    'stroke': '#2F2F2B',
                    'stroke-width': '2'
                }), _createElement('path', {
                    'd': 'M9 9L12 12',
                    'stroke': '#2F2F2B',
                    'stroke-width': '2',
                    'stroke-linejoin': 'round'
                }))] : null, 'Search\n  '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__clear cm_button cm_button__secondary',
                'onClick': this.discardVehicle,
                'disabled': !this.allowToDiscardVehicle,
                'role': 'button',
                'tabIndex': this.allowToDiscardVehicle ? '0' : '-1'
            }, '\n    Reset\n  ')))) : null, this.template === 'locked' ? _createElement('div', {
                'className': 'cm_vehicle-widget_label cmTemplate_locked',
                'key': '7236'
            }, _createElement('div', { 'className': 'cm_vehicle-widget_title' }, '\n  ', this.vehicleString, '\n  ', _createElement('span', { 'className': 'cm_vehicle-widget_subtitle' }, this.fitmentSearchTitle), [this.facetToggle(function () {
                    return _createElement('div', { 'className': 'cm_facetToggle' }, _createElement('span', {
                        'className': 'cm_facet-toggle_label',
                        'onClick': this.toggleFacet
                    }, '\n  ', _translate(`facet_toggle_label`), '\n'), _createElement('label', { 'className': 'cm_facet-toggle_switch' }, _createElement('input', {
                        'className': 'cm_facet-toggle_input',
                        'type': 'checkbox',
                        'checked': this.isToggled,
                        'onChange': this.toggleFacet
                    }), _createElement('span', { 'className': 'cm_facet-toggle_slider' })));
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })]), _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement('div', { 'className': 'cm_vehicle-widget_button-container' }, _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget__change cm_button cm_button__primary',
                'onClick': this.changeVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, '\n      ', _translate(`ymm_bar_change`), '\n    '), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget__discard cm_button cm_button__secondary',
                'onClick': this.discardVehicle,
                'role': 'button',
                'tabIndex': '0'
            }, '\n      ', _translate(`ymm_bar_discard`), '\n    ')))) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })], _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-categories__letters cmRepeater_alphabeticalLetters' },
        _map(this.alphabeticalLetters, repeatAlphabeticalLetters1.bind(this))
    ]), scopeView3.apply(this, []));
}
        export const componentNames = ["cm:filterInput","cm:facetToggle","cm:vehicleWidget"]